import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propFunc, propBool, propOneOf, } from '../../../../../helpers/custom-prop-types';
import RegistrationLink from '../../../../Ui/Registration/RegistrationLink';
import ProfessionalUnitCompanySubscribeButton from '../../Parts/ProfessionalUnitCompanySubscribeButton';
import ProfessionalUnitCompanySubscribeButtonInner from '../../Parts/ProfessionalUnitCompanySubscribeButtonInner';
const ProfessionalUnitCompanyContactButton = (props) => {
    const { checked, onChange, showAlertModal, userMode } = props;
    const isGuest = userMode === 'guest';
    const isView = userMode === 'view';
    const onClick = useMemo(() => {
        switch (userMode) {
            case 'pre':
            case 'other':
                return showAlertModal;
            default:
                return undefined;
        }
    }, [showAlertModal, userMode]);
    if (!isView) {
        return (_jsx(RegistrationLink, { className: 'unit_subscribe_button', isNoLinkComponent: isGuest ? undefined : 'button', onClick: isGuest ? undefined : onClick, text: _jsx(ProfessionalUnitCompanySubscribeButtonInner, { checked: checked }) }));
    }
    return (_jsx(ProfessionalUnitCompanySubscribeButton, { checked: checked, onChange: onChange }));
};
ProfessionalUnitCompanyContactButton.propTypes = {
    checked: propBool().isRequired,
    onChange: propFunc().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitCompanyContactButton;
